// shared/hooks/useUpdatePublicProfile.js
import { useState } from 'react';
import updatePublicProfile from '../data/updatePublicProfile';
import { useNotify } from '../context/NotificationContext';

export default function useUpdatePublicProfile(token) {
  const [updating, setUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  const notify = useNotify();

  const updateProfile = async (profile) => {
    setUpdating(true);
    setUpdateError(null);

    try {
      const result = await updatePublicProfile(token, profile);
      notify.show(
        profile.isVisible
          ? 'Public profile saved and visible'
          : 'Public profile saved and hidden'
      );
      return result;
    } catch (err) {
      console.error('Failed to update public profile:', err);
      setUpdateError(err);
      notify.show(err.message || 'Failed to update public profile');
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  return { updateProfile, updating, updateError };
}
